import { AfterViewInit, Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import SignaturePad from 'signature_pad';

@Component({
  selector: 'app-signature-pad',
  templateUrl: './signature-pad.component.html',
  styleUrls: ['./signature-pad.component.scss']
})
export class SignaturePadComponent implements AfterViewInit {
  @ViewChild('canvas') canvasRef!: ElementRef<HTMLCanvasElement>;
  @Output() signatureSaved = new EventEmitter<string>();
  @Output() cleanSignature = new EventEmitter<string>();

  constructor(private router: Router){}

  private signaturePad!: SignaturePad;
  puedeContinuar = false

  ngAfterViewInit(): void {
  
    const canvas = this.canvasRef.nativeElement;

    canvas.width = canvas.offsetWidth;
    canvas.height = 180;

    this.signaturePad = new SignaturePad(canvas);
  }

  verificarFirma(): void {
    this.puedeContinuar = !this.signaturePad.isEmpty();
    if(this.puedeContinuar){
      const dataUrl = this.signaturePad.toDataURL();
      this.signatureSaved.emit(dataUrl);
    }
  }

  clear(): void {
    this.signaturePad.clear();
    this.cleanSignature.emit()
  }

  save(): void {
    const dataUrl = this.signaturePad.toDataURL();
    this.signatureSaved.emit(dataUrl); // Emitimos la firma
  }

  getUrl(){
    if(this.router.url.includes('consulta')){
      return false
    }
    return true
  }
}
